// 参数格式转成Formdate格式
import { FormGroup } from '@angular/forms';
import { AES, LibWordArray, WordArray, mode, pad, enc } from 'crypto-js';

/**
 * 对字符串进行加密
 * @param str 要加密的字符串
 * @param key base64解析后的key
 * @param iv  base64解析后的key
 * @returns 加密后从字符串
 */
function enCrypt(str: string | LibWordArray, key: string | WordArray, iv: string | LibWordArray): string {
    const tmpAES = AES.encrypt(str, key, {
        iv,
        mode: mode.CBC,
        padding: pad.Pkcs7
    });
    return tmpAES.ciphertext.toString();
}

/**
 * 对字符串进行加密
 * @param str  要加密的字符串
 * @param key  附加的key
 */
export function encrypt(str: string | LibWordArray, key: string): string {
    const k = enc.Base64.parse(key);
    return enCrypt(str.toString(enc.Utf8), k, k);
}

/**
 * 对字符串进行解密
 * @param str 加密后的字符串
 * @param key base64解析后的key
 * @param iv  base64解析后的key
 * @returns 解密后从字符串
 */
function deCrypt(str: string | WordArray, key: string | WordArray, iv: string | LibWordArray): string {
    const tmpDeAES = AES.decrypt(str, key, {
        iv,
        mode: mode.CBC,
        padding: pad.Pkcs7
    });
    return tmpDeAES.toString(enc.Utf8);
}

/**
 * 对字符串进行解密
 * @param str  加密后的字符串
 * @param key  附加的key
 * @returns 解密后从字符串
 */
export function decrypt(str: string, key: string): string {
    const s = enc.Base64.stringify(enc.Hex.parse(str));
    const k = enc.Base64.parse(key);
    return deCrypt(s, k, k);
}

export function generateFormData(param: any): FormData {
    const formData: FormData = new FormData();
    Object.keys(param).forEach(key => {
        formData.set(key, param[key] === null ? '' : param[key]);
    });
    return formData;
}

/*
   @单选行（选中后check为true，行改变背景色,也可用在树形控件上）
      rowOpenid      传过来的行数据的openid
      listData  当前页面的数据列表用于循环，排它（前提是必须给行加id为{{ data.openid }}）
  */
export function radioRow(rowOpenid: any, listData: any) {
    console.log(listData);
    // tslint:disable-next-line: no-unused-expression
    for (const item of listData) {
        // tslint:disable-next-line: prefer-conditional-expression
        if (item.children) {
            radioRow(rowOpenid, item.children);
        } else {
            if (item.openid === rowOpenid || item.id === rowOpenid || item.userId === rowOpenid) {
                item.check = true;
                item.edit = true;
                document.getElementById(rowOpenid).style.background = '#e6f7ff';
            } else {
                item.check = false;
                item.edit = false;
                let id: string;
                if (item.userId) {
                    id = item.userId;
                } else if (item.id) {
                    id = item.id;
                } else {
                    id = item.openid;
                }
                document.getElementById(id).style.background = '';
            }
        }
    }
}

/*
  @多选行（选中后的行check为true，行改变背景颜色，选中行的openid push到一个数组里面，取消选中后把该openid从数组中切掉）
    tableData  当前table列表的data
    rowData    当前行传过来的行数据
    ids        当选中当前行时，要把当前行的openid push到的数组
*/
export function checkRows(tableData: any, rowData: any, ids: any) {
    for (const item of tableData) {
        // tslint:disable-next-line: prefer-conditional-expression
        if (item.openid === rowData.openid) {
            item.check = !item.check;
            // tslint:disable-next-line: prefer-conditional-expression
            if (item.check === true) {
                if (ids.indexOf(item.openid) === -1) {
                    ids.push(item.openid);
                }
                console.log(ids);
                document.getElementById(item.openid).style.background = '#e6f7ff';
            } else {
                if (ids.indexOf(item.openid) !== -1) {
                    ids.splice(ids.indexOf(item.openid), 1);
                    console.log(ids);
                }
                document.getElementById(item.openid).style.background = 'none';
            }
        }
    }
}

// ------------------ 最新列表选择功能开始 ---------------------------------

/*
    @单选行
       rowData:  被点击行的数据
      listData:  当前列表的数据
           arr:  传过来一个数组用于存储该行的openid
*/
export function radioLine(rowData: any, listData: any, arr?: any) {
    rowData.check = true;
    if (arr) {
        arr.length = [];
        if (arr.indexOf(rowData.openid === -1)) {
            arr.push(rowData.openid);
        }
    }
    listData.forEach((element: any) => {
        if (element.openid !== rowData.openid) {
            element.check = false;
        }
    });
}

/**
 * 单选行。在选中与取消选中之间切换
 * @param rowData   被点击行的数据
 * @param listData  当前列表的数据
 * @param arr       传过来一个数组用于存储该行的openid
 */
export function clickLine(rowData: any, listData: any, arr?: any) {
    rowData.check = !rowData.check;
    if (arr) {
        arr.length = [];
        if (arr.indexOf(rowData.openid === -1)) {
            arr.push(rowData.openid);
        }
    }
    listData.forEach((element: any) => {
        if (element.openid !== rowData.openid) {
            element.check = false;
        }
    });
}

/*
    @多选行
        rowData:  被点击行的数据
            arr:  存储选中行的openid
*/
export function multipleLines(rowData: any, arrs: any, names?: any) {
    rowData.check = !rowData.check;
    if (rowData.check) {
        if (arrs.indexOf(rowData.openid) === -1) {
            arrs.push(rowData.openid);
        }
        if (rowData.name && names) {
            if (names.indexOf(rowData.name) === -1) {
                names.push(rowData.name);
            }
        }
    } else {
        if (arrs.indexOf(rowData.openid) !== -1) {
            const index = arrs.indexOf(rowData.openid);
            arrs.splice(index, 1);
        }
        if (rowData.name && names) {
            if (names.indexOf(rowData.name) !== -1) {
                const index = names.indexOf(rowData.name);
                names.splice(index, 1);
            }
        }
    }
}

/*
    @全选/反选
        isCheckAll:  是否全选
          listData:  列表数据
              arrs:  接收选中状态下的openid
*/
export function thCheckAll(isCheckAll: boolean, listData: any, arrs: any) {
    if (isCheckAll) {
        listData.forEach((row: any) => {
            row.check = true;
            if (arrs.indexOf(row.openid) === -1) {
                arrs.push(row.openid);
            }
        });
    } else {
        listData.forEach((row: any) => {
            row.check = false;
            // 不能直接将arr置为空数组，因为有翻页的情况
            if (arrs.indexOf(row.openid) !== -1) {
                const index = arrs.indexOf(row.openid);
                arrs.splice(index, 1);
            }
        });
    }
}

// ------------------ 最新列表选择功能结束 ---------------------------------

/*
  @清除弹出框的值
    inputName 文本框内显示的名称
    inputValue 名称对应的值（一般都是openid）
*/
export function clearInput(inputName?: string, inputValue?: string) {
    console.log(inputName);
    console.log(inputValue);
    inputName = ' ';
    inputValue = ' ';
}

// 过滤请求到的权限树数据
export function filterPermissions(data: any, res = []) {
    data.forEach((item: any) => {
        if (item.children) {
            this.filterPermissions(item.children);
        } else {
            item.isLeaf = true;
        }
        item.title = item.text || item.name;
        if (item.id === '' || item.openid === '') {
            item.key = '';
        } else {
            item.key = item.id || item.openid;
        }
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < res.length; i++) {
            if (res[i].openid === item.key) {
                item.checked = true;
            }
        }
    });
}

export function filterTreeData(data: any) {
    data.forEach((item: any) => {
        if (item.children) {
            this.filterTreeData(item.children);
        } else {
            item.isLeaf = true;
        }
    });
}

/*
 根据新对象修改原对象中的值
 @param oldData 原对象
 @param newData 新对象
*/
export function getNewData(oldData: any, newData: any): any {
    for (const key in oldData) {
        if (newData.hasOwnProperty(key)) {
            oldData[key] = newData[key];
        }
    }
    return oldData;
}

/**
 * 将日期格式转换成日期格式
 * @param date 日期
 */
export function getDateFormat(date: Date): string {
    const da = new Date(date);
    return da.getFullYear() + '-' + fullDate(da.getMonth() + 1) + '-' + fullDate(da.getDate());
}

/**
 * 将日期格式转换成带有时分秒的日期格式
 * @param date 日期
 */
export function getDateTimeFormat(date: Date): string {
    const da = new Date(date);
    return (
        date.getFullYear() +
        '-' +
        fullDate(da.getMonth() + 1) +
        '-' +
        fullDate(da.getDate()) +
        ' ' +
        fullDate(da.getHours()) +
        ':' +
        fullDate(da.getMinutes()) +
        ':' +
        fullDate(da.getSeconds())
    );
}

/**
 * 将日期数字转换成完整的日期字符串
 * @param oldNum 原日期的数字
 */
export function fullDate(oldNum: number): string {
    const str = oldNum + '';
    if (str.length === 1) {
        return '0' + str;
    }
    return str;
}

/**
 * 筛选字符串数据
 * @param oldStr 原数据
 */
export function setNullStr(oldStr: any): any {
    if (typeof oldStr === 'string' || oldStr === null) {
        // console.log("字符串的值：" + oldStr);
        return oldStr === null || oldStr === undefined ? '' : oldStr;
    }
    return oldStr;
}

/**
 * map转化为对象（map所有键都是字符串，可以将其转换为对象）
 * @param strMap 要转换的map字符串
 */
export function strMapToObj(strMap: string): Map<string, any> {
    const obj = Object.create(null);
    for (const [k, v] of strMap) {
        obj[k] = v;
    }
    return obj;
}

/**
 * 对象转换为Map
 * @param obj 要转换的对象
 */
export function objToStrMap(obj: any) {
    const strMap = new Map();
    for (const k of Object.keys(obj)) {
        strMap.set(k, obj[k]);
    }
    return strMap;
}

/**
 * 将日期字符串转换成date
 * @param rq 日期字符串。格式yyyy-mm-dd
 */
export function getYearMonthDate(rq: string): Date {
    if (rq !== null && rq !== undefined && rq !== '') {
        const sj = new Date();
        const start = rq;
        const startarr = start.split('-');
        // tslint:disable-next-line: radix
        sj.setFullYear(Number.parseInt(startarr[0]), Number.parseInt(startarr[1]) - 1, Number.parseInt(startarr[2]));
        return sj;
    }
    return null;
}

/**
 * 月日格式字符串  01-01
 * @param rq 日期 string类型
 * @returns 注意：返回的日期 月份比实际值小一（建议只在使用该控件时使用）
 */
export function getMonthDate(rq: string): Date {
    if (rq !== null && rq !== undefined && rq !== '') {
        const sj = new Date();
        const start = rq;
        const startarr = start.split('-');
        // tslint:disable-next-line: radix
        sj.setMonth(Number.parseInt(startarr[0]) - 1, Number.parseInt(startarr[1]));
        return sj;
    }
    return null;
}

/**
 * 删除数据后刷新列表时获取页码
 * @param oldPage  原页码
 * @param listData 原列表数据
 * @returns 新页码
 */
export function getNewPage(oldPage: number, listData: any): number {
    if (listData.length > 1) {
        return oldPage;
    }
    if (oldPage > 1) {
        return oldPage - 1;
    }
    return 1;
}

// 生成数组
export function generateArr(num: number) {
    const array = [];
    for (let i = 1; i <= num; i++) {
        array.push(i);
    }
    return array;
}

// 如果字符串为null或者 undefined 则返回 ''，否则为本身
export function formStr(str: string): string {
    return str === null || str === undefined ? '' : str;
}

// 如果数字为null或者 undefined 则返回 0，否则为本身
export function formNum(str: number, defaultValue?: number): number {
    return str === null || str === undefined ? (defaultValue ? defaultValue : 0) : str;
}

export function generateDate(date: Date) {
    function filterVal(val) {
        if (val < 10) val = '0' + val;
        return val;
    }
    const rq = new Date(date);
    const Y = rq.getFullYear();
    const M = filterVal(rq.getMonth() + 1);
    const D = filterVal(rq.getDate());
    return Y + '-' + M + '-' + D;
}

// 时间转换成yyyy-mm-dd hh:mm:ss
export function generateTime(date: Date) {

    function filterVal(val) {
        if (val < 10) val = '0' + val;
        return val;
    }
    const rq = new Date(date);
    const Y = rq.getFullYear();
    const M = filterVal(rq.getMonth() + 1);
    const D = filterVal(rq.getDate());
    const h = filterVal(rq.getHours());
    const m = filterVal(rq.getMinutes());
    const s = filterVal(rq.getSeconds());
    console.log("===================");
    return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s;
}

// 表单验证
export function validateForm(form: FormGroup) {
    for (const i in form.controls) {
        if (form.controls.hasOwnProperty(i)) {
            form.controls[i].markAsDirty();
            form.controls[i].updateValueAndValidity();
        }
    }
    // 验证是否通过
    if (form.valid) { // 验证通过
        return true;
    } else {
        return false;
    }
}

export function cloneData(data: any) {
    const newData = new Object();
    // tslint:disable-next-line:forin
    for (const key in data) {
        newData[key] = data[key];
    }
    return newData;
}

// tslint:disable-next-line: only-arrow-functions
export const loseFocus = function (e?: any) {
    if (e) {
        e.target.blur();
    }
}


